import { Link, useLocation } from 'react-router-dom'
import { useState } from "react"
import { MailOpen, Newspaper, Puzzle, Users, Bell, FileText, Key, Webhook } from 'lucide-react'
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from '../../ui/sidebar'
import { ROUTES } from '../../../config/routes'
import { useAuth } from '../../../lib/auth.context'
import { usePartner } from '../../../lib/hooks/usePartner'

const getMenuItems = (partnerId: string | null) => [
  {
    title: 'Dashboard',
    icon: MailOpen,
    href: ROUTES.PARTNER.DASHBOARD,
  },
  {
    title: 'Transactions',
    icon: Newspaper,
    href: ROUTES.PARTNER.TRANSACTIONS,
  },
  {
    title: 'Integrations',
    icon: Puzzle,
    href: ROUTES.PARTNER.INTEGRATIONS,
  },
  {
    title: 'Merchants',
    icon: Users,
    href: ROUTES.ADMIN.MERCHANTS,
  },
  {
    title: 'API Keys',
    icon: Key,
    href: ROUTES.PARTNER.API_KEYS,
  },
  {
    title: 'Webhooks',
    icon: Webhook,
    href: ROUTES.PARTNER.WEBHOOKS,
  },
  {
    title: 'Notifications',
    icon: Bell,
    href: ROUTES.PARTNER.NOTIFICATIONS,
  },
  {
    title: 'Documentation',
    icon: FileText,
    href: ROUTES.PARTNER.DOCUMENTATION,
  },
]

export function SidebarNav() {
  const location = useLocation()
  const { status } = useAuth()
  const { partnerId } = usePartner()
  const isAuthenticated = status === 'authenticated'

  // Helper function to check if a menu item is active
  const isMenuItemActive = (itemHref: string) => {
    // Exact match
    if (location.pathname === itemHref) {
      return true
    }

    // Special case for nested routes (if needed)
    if (itemHref !== '/' && location.pathname.startsWith(itemHref)) {
      // Only match if it's a direct child route or has a trailing slash
      const remainingPath = location.pathname.slice(itemHref.length)
      if (remainingPath === '' || remainingPath === '/' || remainingPath.startsWith('/')) {
        return true
      }
    }

    return false
  }

  // Log navigation state for debugging
  console.log('[SidebarNav] Current path:', location.pathname)
  console.log('[SidebarNav] isAuthenticated:', isAuthenticated)

  return (
    <Sidebar className="fixed">
      <SidebarHeader className="px-4 py-6">
        <Link to={isAuthenticated ? ROUTES.PARTNER.DASHBOARD : ROUTES.PUBLIC.LOGIN} className="flex items-center gap-4">
          <div className="rounded bg-white/10 p-1">
            {/* <img
              alt="Logo"
              className="h-6 w-6"
            /> */}
          </div>
          <span className="font-bold text-lavender-900">FanFair</span>
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu className="px-8 gap-2 text-lavender-600">
          {getMenuItems(partnerId).map((item) => {
            const active = isMenuItemActive(item.href)

            // Log active state for debugging
            if (item.title === 'Transactions') {
              console.log(`[SidebarNav] Transactions menu item active: ${active}`)
              console.log(`[SidebarNav] Transactions href: ${item.href}, current path: ${location.pathname}`)
            }

            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  asChild
                  isActive={active}
                  className="hover:bg-lavender-200 data-[active=true]:bg-lavender-200"
                  tooltip={item.title}
                >
                  <Link
                    to={item.href}
                    className="flex items-center gap-3"
                    onClick={() => console.log(`[SidebarNav] Clicked on ${item.title} menu item`)}
                  >
                    <item.icon className="h-4 w-4" color="#354297" />
                    <span className="font-medium">{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            )
          })}
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  )
}
